import { MessageSquareText } from "lucide-react";
import { lazy, Suspense, useState } from "react";
import type { SmsOwner } from "@/lib/sms";
import { cn } from "@/lib/utils";

// The dialog is its own chunk: the entry bundle has a 200 kB gzipped budget, and most page loads never text.
const TextDialog = lazy(() => import("./TextDialog").then((m) => ({ default: m.TextDialog })));

/** "Text" beside Dial (P3.3): opens the dialog. */
export function TextButton({
  owner,
  phones,
  phone,
  className,
  compact = false,
  label = "Text",
  testId = "text-button",
  initialBody,
  outboxId,
  templateId,
  onSent,
}: {
  owner: SmsOwner;
  phones: readonly string[];
  phone?: string | null;
  className?: string;
  compact?: boolean;
  label?: string;
  testId?: string;
  initialBody?: string;
  outboxId?: string | null;
  templateId?: string | null;
  onSent?: () => void;
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
        disabled={phones.length === 0 && !phone}
        data-testid={testId}
        className={cn(
          "inline-flex items-center gap-1 rounded-md border font-medium hover:bg-surface-2 disabled:opacity-50",
          compact ? "px-1.5 py-0.5 text-[11px]" : "min-h-9 px-3 text-sm pointer-coarse:min-h-11",
          className,
        )}
      >
        <MessageSquareText className={compact ? "size-3" : "size-4"} aria-hidden />
        {label}
      </button>
      {open && (
        <Suspense fallback={null}>
          <TextDialog
          owner={owner}
          phones={phone && !phones.includes(phone) ? [phone, ...phones] : phones}
          initialPhone={phone}
          initialBody={initialBody}
          outboxId={outboxId}
          templateId={templateId}
          onClose={() => setOpen(false)}
          onSent={onSent}
          />
        </Suspense>
      )}
    </>
  );
}
